var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "card card-login" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "text-login" }, [
            _vm._v(_vm._s(_vm.$t("general.system_name")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-box" }, [
            _c("div", { staticClass: "text-center mt-1" }, [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("login.pc_input_code_message"))
                }
              })
            ]),
            _vm._v(" "),
            _vm.url
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-center d-flex justify-content-center mt-3"
                  },
                  [
                    _c("vue-qrcode", {
                      attrs: { value: _vm.url, options: { scale: 6 } }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 d-flex" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-pink-53 w-100",
                  on: {
                    click: function($event) {
                      return _vm.next()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("button.next")) +
                      "\n              "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "logo-link", attrs: { href: "#" } }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo_jtb_wht@2x.png"), alt: "Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-268b918e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-268b918e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/pc/Login/LoginFirstMfa.vue
// module id = null
// module chunks = 